export default "__VITE_ASSET__DMGfZo6l__"